import { useEffect, useState } from 'react';
import { PropTypes } from 'prop-types';
import { useNavigate, useOutletContext, useParams } from 'react-router-dom';
import AccionaButton from '../../components/AccionaButton';
import AccionaDropdown from '../../components/AccionaDropdown';
import AccionaResult from '../../components/AccionaResult';
import { getProjectTemplates } from '../../services/api/projectTemplates';
import { useIntl } from 'react-intl';
//success page component

const ProviderRecognised = ({
  fileName,
  template,
  onBack,
  model,
  preProcessedId,
}) => {
  const intl = useIntl();
  const { project } = useOutletContext();
  const navigate = useNavigate();
  const [templateList, setTemplateList] = useState([
    { id: '0', supplier: 'createTemplate' },
  ]);
  const [selectedTemplate, setSelectedTemplate] = useState({
    id: '0',
    supplier: 'createTemplate',
  });
  const { id: pid } = useParams();

  useEffect(() => {
    const createTemplate = { id: '0', supplier: 'createTemplate' };

    if (model) {
      if (template.id) setSelectedTemplate(template);
      else setSelectedTemplate(createTemplate);
      getProjectTemplates({
        page: 1,
        size: 20,
        filters: { model: model, pid },
      }).then((response) => {
        setTemplateList((prev) => prev.concat(response.data.templates));
      });
    }
  }, [model, template, setSelectedTemplate, pid]);

  const onClick = (selected) => setSelectedTemplate(selected);

  const createButtonHandler = () => {
    if (preProcessedId) {
      selectedTemplate.id !== '0'
        ? navigate(
            `/app/project/${project.id_project}/quality/ocr/readDocument/preDocument/${selectedTemplate.model}/${selectedTemplate.id}/${preProcessedId}/${fileName}`,
          )
        : navigate(
            `/app/project/${project.id_project}/quality/ocr/newTemplateToSD/preDocument/${model}/${preProcessedId}/${fileName}`,
          );
    } else {
      selectedTemplate.id !== '0'
        ? navigate(
            `/app/project/${project.id_project}/quality/ocr/readDocument/${selectedTemplate.model}/${selectedTemplate.id}/${fileName}`,
          )
        : navigate(
            `/app/project/${project.id_project}/quality/ocr/newTemplateToSD/${model}/${fileName}`,
          );
    }
  };

  return (
    <AccionaResult
      id="newDoc"
      icon={
        <i className="far fa-lightbulb fa-8x" style={{ color: '#ff0000' }} />
      }
      title={intl.formatMessage({ id: 'supplier.search' })}
      extra={[
        <div key="1" style={{ marginTop: '24px' }}>
          <h2 style={{ textAlign: 'center' }}>
            {intl.formatMessage({ id: 'pages.templateList.selectAction' })}
          </h2>
          <div className="form-row">
            <div
              style={{
                witdth: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'center',
              }}
            >
              <AccionaDropdown
                width="550px"
                attr="supplier"
                selected={selectedTemplate}
                onClick={onClick}
                options={templateList}
              ></AccionaDropdown>
            </div>
          </div>
          <div
            className="form-row"
            style={{ display: 'flex', justifyContent: 'center' }}
          >
            <AccionaButton
              msg={intl.formatMessage({ id: 'back' })}
              classIcon="icon fas fa-chevron-left"
              id="backBtn"
              onClick={onBack}
            />
            <AccionaButton
              id="continueBtn"
              classIconRight="icon-right fas fa-chevron-right"
              msg={intl.formatMessage({ id: 'continue' })}
              onClick={createButtonHandler}
            />
          </div>
        </div>,
      ]}
    />
  );
};
ProviderRecognised.propTypes = {
  fileName: PropTypes.string.isRequired,
  template: PropTypes.shape({
    id: PropTypes.string,
  }).isRequired,
  onBack: PropTypes.func.isRequired,
  model: PropTypes.string.isRequired,
  preProcessedId: PropTypes.string.isRequired,
};

ProviderRecognised.propTypes = {
  fileName: PropTypes.string.isRequired,
  template: PropTypes.shape({
    id: PropTypes.string,
  }).isRequired,
  onBack: PropTypes.func,
  preProcessedId: PropTypes.string,
  model: PropTypes.string,
};

ProviderRecognised.defaultProps = {
  onBack: () => {},
  preProcessedId: undefined,
  model: undefined,
};

export default ProviderRecognised;
